
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { RealtorProfileService } from '../realtor-profile.service';
import { RealtorProfile } from '../realtor-profile';
import { OwnerProfileService } from '../../owner-profile/owner-profile.service';
import { MsgTemplateData } from '@app/_components/msg-template/msg-template-data';

@Component({
    selector: 'app-realtor-profile',
    templateUrl: './realtor-profile.component.html',
    styleUrls: ['./realtor-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RealtorProfileComponent implements OnInit {

    properties: any;
	users: any;
	isDisplayRealtorProfile : boolean = false;
	portalAccesses: any;
	listingStatuses: any;
	titles: any;
	countries: any;
	states: any;
	isRealtorLoaded = false;
	msgTemplateData: MsgTemplateData;

	constructor(
		private primengConfig: PrimeNGConfig,
		private realtorProfileService: RealtorProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private ownerProfileService: OwnerProfileService,
		private confirmationService: ConfirmationService,
		private constantService: ConstantService,
		private formBuilder: FormBuilder,
		private userService: UserService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.realtorProfile = data.realtorProfile,
			//this.realtorProfileId = data.realtorProfile?.realtorProfileId;
			this.statuses = realtorProfileService.statuses;
			this.agntSaleSidePrefs = realtorProfileService.agntSaleSidePrefs;
			this.agntLeadsPrefs = realtorProfileService.agntLeadsPrefs;
			this.listingStatuses = realtorProfileService.listingStatuses;
			this.portalAccesses = ownerProfileService.portalAccesses;
			this.titles = realtorProfileService.titles;
			this.countries = this.constantService.countries; 
			this.states = this.constantService.states;
	}

	@Input() realtorProfile: RealtorProfile;
	@Output() doAddRealtor = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Output() doClose = new EventEmitter<any>();


	// data
	realtorProfileId: number;

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;
	agntSaleSidePrefs: any;
	agntLeadsPrefs: any;
	//addressTypes: any;

	validationMessages = {
		'realtorProfileId': [],
		'firstName': [{ type: 'required', message: 'First Name Required' }],
		'lastName': [{ type: 'required', message: 'Last Name Required' }],
		'suffix': [],
		'title': [],
		'emailAddress': [],
		'mobilePhone': [],
		'licenseNum': [],
		'agntSaleSidePref': [],
		'agntLeadsPref': [],
		'adrType': [],
		'adrCompanyName': [],
		'adrStreet': [],
		'adrStreet2': [],
		'adrCity': [],
		'adrState': [],
		'adrPostalCode': [],
		'adrCountry': [],
		'adrPhone': [],
		'adrFax': [],
		'family': [],
		'favSports': [],
		'education': [],
		'politics': [],
		'contactPref': [],
		'opsNotes': [],
		portalAccessBasic:  [],
		listingStatus:  [],
	};

	ngOnInit() {
		this.fetchUsers();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole realtorProfile object
		if (this.realtorProfile) {
			this.realtorProfileId = this.realtorProfile.realtorProfileId;
			this.fixDates();
			this.form1.patchValue(this.realtorProfile);
			this.isDisplayRealtorProfile = true;
			if(this.realtorProfile.portalAccessBasic != true){
				this.realtorProfile.portalAccessBasic = false;
			}
			this.setTemplateData(this.realtorProfile)
		}
		//Default make form as dirty
		this.form1.markAllAsTouched();
	}

	setTemplateData(realtorProfile: any) {
		this.msgTemplateData = new MsgTemplateData();
		let firstName = realtorProfile?.firstName ? realtorProfile?.firstName : '';
		let lastName = realtorProfile?.lastName ? realtorProfile?.lastName : '';
		this.msgTemplateData.firstName =  firstName + ' ' + lastName;
		this.msgTemplateData.lastName = lastName;
		this.msgTemplateData.realtorProfileId = this.realtorProfileId;
		this.msgTemplateData.emailAddress = realtorProfile?.emailAddress;
		this.msgTemplateData.mobilePhone = realtorProfile?.mobilePhone;
		this.isRealtorLoaded = true;
		return this.msgTemplateData;
	  }

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.realtorProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.realtorProfileService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.realtorProfile = res.data.realtorProfile;
						//this.realtorProfileId = this.realtorProfile.realtorProfileId;
						this.doAddRealtor.emit(this.realtorProfile);
					},
					(err: any) => {
						console.log('realtorProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('realtorProfile: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.form1.value.realtorProfileId = this.realtorProfileId;
			this.realtorProfileService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.realtorProfile = res.data.realtorProfile;
						this.doUpdate.emit(this.realtorProfile);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.realtorProfileService.delete(this.realtorProfile.realtorProfileId)
				.subscribe(
					(res: any) => {
						console.log('realtorProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.realtorProfile);
					},
					(err: any) => {
						console.log('realtorProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			realtorProfileId: [this.realtorProfileId],
			firstName: ['', Validators.required],
			lastName: ['', Validators.required],
			suffix: [],
			title: [],
			emailAddress: [],
			mobilePhone: [],
			licenseNum: [],
			agntSaleSidePref: [],
			agntLeadsPref: [],
			adrType: [],
			adrCompanyName: [],
			adrStreet: [],
			adrStreet2: [],
			adrCity: [],
			adrState: [],
			adrPostalCode: [],
			adrCountry: [],
			adrPhone: [],
			adrFax: [],
			family: [],
			favSports: [],
			education: [],
			politics: [],
			contactPref: [],
			opsNotes: [],
			portalAccessBasic:  ['false'],
			listingStatus:  [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.realtorProfile.realtorProfileDate = moment(this.realtorProfile.realtorProfileDate).toDate();
	}

	// update realtor portal access
	updateRealtorPortalAccess() {
		console.log('realtorProfile: ' + JSON.stringify(this.form1.value));
			try {
				// stop here if form is invalid
				this.form1.markAllAsTouched();
				if (this.form1.invalid) {
					return;
				}
				this.formLoading = true;

				this.realtorProfileService.updateRealtorPortalAccess(this.form1.value)
					.subscribe(
						(res: any) => {
							console.log('realtor-update SUCCESS: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
							this.realtorProfile = res.data.realtorProfile;
							// this.doUpdateAccess.emit(this.realtorProfile);
						},
						(err: any) => {
							console.log('realtor-update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.formLoading = false; });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

	fetchUsers() {
		if (!this.users || this.users === undefined || this.users.length < 1) {
			try {
				this.userService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.users = res.data.users;
							return this.users;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}
}
